import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { darkColors } from '../constants/colors';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';
import { AppButton } from './AppButton';

type Props = {
  message: string;
  requestId?: string | null;
  onRetry?: () => void;
};

export function ErrorState({ message, requestId, onRetry }: Props) {
  const palette = useAppColors();
  const isDark = palette.background === darkColors.background;

  return (
    <View
      accessibilityRole="alert"
      accessibilityLabel={message}
      style={[
        styles.container,
        isDark ? styles.containerDark : styles.containerLight,
      ]}
    >
      <Text style={[styles.title, { color: palette.error }]}>
        Something went wrong
      </Text>
      <Text style={[styles.message, { color: palette.textSecondary }]}>
        {message}
      </Text>
      {requestId ? (
        <Text style={[styles.request, { color: palette.textMuted }]}>
          Request ID: {requestId}
        </Text>
      ) : null}
      {onRetry ? (
        <AppButton title="Retry" onPress={onRetry} variant="secondary" />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.md,
    padding: spacing.lg,
    borderRadius: 12,
    borderWidth: 1,
  },
  containerLight: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
  },
  containerDark: {
    backgroundColor: '#3B1C1C',
    borderColor: '#912018',
  },
  title: { ...typography.sectionTitle },
  message: { ...typography.body },
  request: { ...typography.caption },
});
